const draggable = {
    mounted(el) {
        let offsetX, offsetY, startX, startY
        // 视口宽度
        let viewportWidth = null
        //视口高度
        let viewportHeight = null

        function handleDown(e) {
            e.stopPropagation()
            viewportWidth = document.documentElement.clientWidth
            viewportHeight = document.documentElement.clientHeight
            if (e.type === 'mousedown') {
                offsetX = e.clientX - el.offsetLeft
                offsetY = e.clientY - el.offsetTop
                document.addEventListener('mousemove', onMouseMove)
                document.addEventListener('mouseup', onMouseUp)
            } else if (e.type === 'touchstart') {
                startX = e.touches[0].clientX - el.offsetLeft
                startY = e.touches[0].clientY - el.offsetTop
                document.addEventListener('touchmove', onTouchMove)
                document.addEventListener('touchend', onTouchEnd)
            }
        }

        function onMouseMove(e) {
            e.stopPropagation()
            el.style.left = `${e.clientX - offsetX}px`
            el.style.top = `${e.clientY - offsetY}px`
            //防止拖动出视口
            if (el.offsetLeft < 0) {
                el.style.left = '0px'
            }
            if (el.offsetLeft + el.offsetWidth >= viewportWidth) {
                el.style.left = `${viewportWidth - el.offsetWidth}px`
            }
            if (el.offsetTop < 0) {
                el.style.top = '0px'
            }
            if (el.offsetTop + el.offsetHeight >= viewportHeight) {
                el.style.top = `${viewportHeight - el.offsetHeight}px`
            }

            el.style.pointerEvents = 'none'
            const iframes = document.getElementById('iframe-room')
            if (iframes) {
                iframes.style.pointerEvents = 'none'
            }
        }

        function onTouchMove(e) {
            el.style.left = `${e.touches[0].clientX - startX}px`
            el.style.top = `${e.touches[0].clientY - startY}px`
            //防止拖动出视口
            if (el.offsetLeft < 0) {
                el.style.left = '0px'
            }
            if (el.offsetLeft + el.offsetWidth >= viewportWidth) {
                el.style.left = `${viewportWidth - el.offsetWidth}px`
            }
            if (el.offsetTop < 0) {
                el.style.top = '0px'
            }
            if (el.offsetTop + el.offsetHeight >= viewportHeight) {
                el.style.top = `${viewportHeight - el.offsetHeight}px`
            }
        }

        function onMouseUp() {
            el.style.pointerEvents = null
            const iframes = document.getElementById('iframe-room')
            if (iframes) {
                iframes.style.pointerEvents = null
            }
            document.removeEventListener('mousemove', onMouseMove)
            document.removeEventListener('mouseup', onMouseUp)
        }

        function onTouchEnd() {
            document.removeEventListener('touchmove', onTouchMove)
            document.removeEventListener('touchend', onTouchEnd)
        }

        el.addEventListener('mousedown', handleDown)
        el.addEventListener('touchstart', handleDown)
    },
}

export default draggable
